var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInProgress48Line = function SvgIconInProgress48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.94 14.52 2.59-2.59a14.776 14.776 0 0 0-6.04-2.5v3.66c1.24.28 2.4.77 3.44 1.43h.01ZM34.91 21.5h3.66c-.38-2.22-1.25-4.27-2.5-6.03l-2.59 2.59c.66 1.05 1.15 2.2 1.43 3.44ZM24 35.2c-6.18 0-11.2-5.02-11.2-11.2 0-5.32 3.73-9.77 8.7-10.91V9.43C14.53 10.62 9.2 16.69 9.2 24c0 8.16 6.64 14.8 14.8 14.8 7.31 0 13.38-5.33 14.57-12.3h-3.66c-1.14 4.97-5.59 8.7-10.91 8.7Z",
    fill: "current"
  })));
};
export default SvgIconInProgress48Line;